export default "/images/TargetedOncology.png?8884b51f9b0afbc9cfc0f51c6c72bf3f";